export enum ButtonVariant {
    unselected = 'unselected',
    primary = 'primary',
    alwaysWhite = 'alwaysWhite',
    purple = 'purple',
    inverted = 'inverted',
    alwaysBlack = 'alwaysBlack',
    danger = 'danger',
    transparent = 'transparent',
    green = 'green',
}

export const buttonVariants = {
    [ButtonVariant.unselected]: {
        background: 'bg-brand-bg-3',
        hover: 'hover:bg-brand-bg-3/90',
        text: 'text-brand-color-2',
        disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.green]: {
        background: 'bg-brand-green',
        hover: 'hover:bg-brand-green/90',
        text: 'text-white',
        disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.primary]: {
        background: 'bg-brand-orange',
        hover: 'hover:opacity-90',
        text: 'text-white',
        disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.alwaysWhite]: {
        background: 'bg-white', //dark:bg-black
        hover: 'hover:bg-gray-100', // dark:hover:bg-gray-800
        text: 'text-black', //dark:text-white
        disabled: 'disabled:bg-white/50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.purple]: {
        background: 'bg-brand-purple',
        hover: 'hover:bg-brand-purple/90',
        text: 'text-white',
        disabled: 'disabled:bg-brand-purple/50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.inverted]: {
        background: 'bg-brand-black dark:bg-brand-white',
        hover: 'hover:bg-brand-black/90',
        text: 'text-white dark:text-black',
        disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.alwaysBlack]: {
        background: 'bg-brand-black',
        hover: 'hover:bg-brand-black/90',
        text: 'text-white',
        disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.danger]: {
        background: 'bg-transparent',
        hover: 'hover:bg-gray-100 dark:hover:bg-gray-800',
        text: 'text-brand-red',
        disabled: 'disabled:bg-white/50 disabled:cursor-not-allowed',
    },
    [ButtonVariant.transparent]: {
        background: 'bg-transparent',
        hover: 'hover:bg-gray-100 dark:hover:bg-gray-800',
        text: 'text-black dark:text-white',
        disabled: 'disabled:bg-white/50 disabled:cursor-not-allowed',
    },
} as const;
